import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import {
  candidateEventSubmissionControlSliceKey,
  initialState,
} from './candidateEventSubmissionControl.redux';

const selectDomain = (state: RootState) =>
  state[candidateEventSubmissionControlSliceKey] || initialState;

export const selectCandidateEventSubmissionControls = createSelector([selectDomain], state => state.items);
export const selectCandidateEventSubmissionControlsForTraveler = createSelector(
  [selectDomain, (_state: RootState, travelerId: number) => travelerId],
  (state, travelerId) => (state.requestedTravelerId === travelerId ? state.items : []),
);
export const selectCandidateEventSubmissionControlLoadingForTraveler = createSelector(
  [selectDomain, (_state: RootState, travelerId: number) => travelerId],
  (state, travelerId) => state.requestedTravelerId === travelerId && state.loading,
);
export type CandidateEventSubmissionControlListStatus = 'idle' | 'loading' | 'success' | 'error';
export const selectCandidateEventSubmissionControlListStatusForTraveler = createSelector(
  [selectDomain, (_state: RootState, travelerId: number) => travelerId],
  (state, travelerId): CandidateEventSubmissionControlListStatus => {
    if (state.requestedTravelerId !== travelerId) {
      return 'idle';
    }
    if (state.loading) {
      return 'loading';
    }
    if (state.listError) {
      return 'error';
    }
    return 'success';
  },
);
export const selectPlacementSubmissionControl = createSelector([selectDomain], state => state.placementControl);
export const selectRequestedPlacementId = createSelector([selectDomain], state => state.requestedPlacementId);
export const selectPlacementSubmissionControlForPlacement = createSelector(
  [selectDomain, (_state: RootState, placementId: number) => placementId],
  (state, placementId) => (state.requestedPlacementId === placementId ? state.placementControl : null),
);
export const selectCandidateEventSubmissionControlLoading = createSelector([selectDomain], state => state.loading);
export const selectPlacementSubmissionControlLoading = createSelector([selectDomain], state => state.placementLoading);
export const selectCandidateEventSubmissionControlSavingAffiliationIds = createSelector(
  [selectDomain],
  state => state.savingAffiliationIds,
);
